import React, { useState, useContext, useCallback, useEffect } from 'react';
import { Button, Modal, Card, Input, message } from "antd";
import { GlobalContext } from "../../../lib/context";
import axios from 'axios';

interface Profile {
  is_trial: boolean;
  trial_remaining_days: number;
}

// interface CardDetails {
//   cardNumber: string;
//   expiryDate: string;
//   cvv: string;
// }

const TrialUpdate: React.FC = () => {
  const token = localStorage.getItem('cxspsa') || '';
  const baseURL = `${process.env.REACT_APP_BACKEND_URL || ""}api/`;
  const { profile, setProfile } = useContext(GlobalContext);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);

  // const [cardDetails, setCardDetails] = useState<CardDetails>({
  //   cardNumber: "",
  //   expiryDate: "",
  //   cvv: "",
  // });

  // const [errors, setErrors] = useState({
  //   cardNumber: "",
  //   expiryDate: "",
  //   cvv: "",
  // });

  // Ensure the component only renders for trial users
  useEffect(() => {
    if (profile?.trial_remaining_days === 0) {
      setIsModalVisible(true);
    }
  }, [profile]);
  if (!profile?.is_trial) {
    return null;
  }

  const showModal = (): void => {
    setIsModalVisible(true);
  };

  const handleOk = useCallback(async () => {
    // const isValid = validateForm();
    // if (isValid) {
      setIsLoading(true);
      try {
        // const formDataToSend = new FormData();
        // formDataToSend.append('card_number', cardDetails.cardNumber);
        // formDataToSend.append('expiry_date', cardDetails.expiryDate);
        // formDataToSend.append('cvv', cardDetails.cvv);

        const response = await axios.post(baseURL + 'upgrade-subscription', {},{
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        if (response.data.success) {
          const hostedPageUrl = response.data.hostedpage_url;

          if (hostedPageUrl) {
            // Redirect to the hosted page URL
            // window.location.href = hostedPageUrl;
            window.open(hostedPageUrl, '_blank');
          } else {
            // If no hosted page URL, handle success normally
            message.success('Subscription upgraded successfully');
            setProfile(response.data.user);
            setIsModalVisible(false);
          }
        } else {
          message.error(response.data.message || 'Upgrade failed');
        }
      } catch (error) {
        message.error('An error occurred while upgrading subscription');
      } finally {
        setIsLoading(false);
      }
    // }
  }, [setProfile, token]);



  const handleCancel = (): void => {
    setIsModalVisible(false);
    // setErrors({ cardNumber: "", expiryDate: "", cvv: "" }); // Clear error messages
  };

  // const handleInputChange =
  //   (field: keyof CardDetails) =>
  //     (e: React.ChangeEvent<HTMLInputElement>) => {
  //       setCardDetails({ ...cardDetails, [field]: e.target.value });

  //       // Perform real-time validation for specific fields
  //       switch (field) {
  //         case "cardNumber":
  //           setErrors({
  //             ...errors,
  //             cardNumber: validateCardNumber(e.target.value)
  //               ? ""
  //               : "Invalid card number.",
  //           });
  //           break;
  //         case "expiryDate":
  //           setErrors({
  //             ...errors,
  //             expiryDate: validateExpiryDate(e.target.value)
  //               ? ""
  //               : "Invalid expiry date (MM/YY).",
  //           });
  //           break;
  //         case "cvv":
  //           setErrors({
  //             ...errors,
  //             cvv: validateCVV(e.target.value) ? "" : "Invalid CVV.",
  //           });
  //           break;
  //         default:
  //           break;
  //       }
  //     };

  // // Custom validation for card number (Luhn algorithm or basic checks)
  // const validateCardNumber = (number: string): boolean => {
  //   const regex = /^[0-9]{13,19}$/; // Card number must be 13 to 19 digits
  //   if (!regex.test(number)) return false;
  //   // return regex.test(number);

  //   // Luhn Algorithm for credit card validation
  //   let sum = 0;
  //   let shouldDouble = false;

  //   for (let i = number.length - 1; i >= 0; i--) {
  //     let digit = parseInt(number.charAt(i));

  //     if (shouldDouble) {
  //       digit *= 2;
  //       if (digit > 9) digit -= 9;
  //     }

  //     sum += digit;
  //     shouldDouble = !shouldDouble;
  //   }

  //   return sum % 10 === 0;
  // };

  // // Custom validation for expiry date (MM/YY format)
  // const validateExpiryDate = (date: string): boolean => {
  //   const regex = /^(0[1-9]|1[0-2])\/\d{2}$/; // Matches MM/YY format
  //   if (!regex.test(date)) {
  //     return false;
  //   }

  //   const [month, year] = date.split("/").map(Number);
  //   const currentYear = new Date().getFullYear() % 100; // Last two digits of the year
  //   const currentMonth = new Date().getMonth() + 1;

  //   return (
  //     (year > currentYear || (year === currentYear && month >= currentMonth)) &&
  //     month >= 1 &&
  //     month <= 12
  //   );
  // };

  // // Custom validation for CVV (3 or 4 digits)
  // const validateCVV = (cvv: string): boolean => {
  //   const regex = /^[0-9]{3,4}$/; // Matches 3 or 4 digits
  //   return regex.test(cvv);
  // };

  // const validateForm = (): boolean => {
  //   const cardNumberValid = validateCardNumber(cardDetails.cardNumber);
  //   const expiryDateValid = validateExpiryDate(cardDetails.expiryDate);
  //   const cvvValid = validateCVV(cardDetails.cvv);

  //   setErrors({
  //     cardNumber: cardNumberValid ? "" : "Invalid card number.",
  //     expiryDate: expiryDateValid ? "" : "Invalid expiry date (MM/YY).",
  //     cvv: cvvValid ? "" : "Invalid CVV.",
  //   });

  //   return cardNumberValid && expiryDateValid && cvvValid;
  // };

  return (
    <div style={{ padding: "10px", width: "300px", textAlign: "center" }}>
      <Button size="small" onClick={showModal} style={{ backgroundColor: 'red', color: 'white', border: 'none' }}
      >
        <b>UPGRADE</b>
      </Button>

      <div
        style={{
          marginTop: "10px",
          color: "red",
          fontWeight: "500",
          fontSize: "smaller",
        }}
      >
        {profile.trial_remaining_days} days trial remaining
      </div>

      <Modal
        title="Upgrade Your Plan"
        open={isModalVisible}
        confirmLoading={isLoading}

        closable={profile?.trial_remaining_days !== 0} // Make it closable only if days are not zero
        onCancel={() => {
          if (profile?.trial_remaining_days !== 0) {
            setIsModalVisible(false);
            // setErrors({ cardNumber: "", expiryDate: "", cvv: "" }); 
          }
        }} // Close modal only if closable
        footer={
            <Button type="primary" onClick={handleOk}  disabled={isLoading}>
              {isLoading ? 'Upgrading...' : 'Upgrade Now'}
            </Button>
        } 
      >
        {/* <Card title="Enter Card Details" bordered={false}> */}
          {/* Card Number Input */}
          {/* <Input
            id="unique-card-number"
            name="unique-card-number"
            autoComplete="new-card-number"
            placeholder="Card Number"
            value={cardDetails.cardNumber}
            onChange={handleInputChange("cardNumber")}
            style={{ marginBottom: "10px" }}
          /> */}
          {/* {errors.cardNumber && (
            <div style={{ color: "red", marginBottom: "10px" }}>
              {errors.cardNumber}
            </div>
          )} */}

          {/* Expiry Date Input */}
          {/* <Input
            id="unique-expiry-date"
            name="unique-expiry-date"
            autoComplete="new-expiry-date"
            placeholder="Expiry Date (MM/YY)"
            value={cardDetails.expiryDate}
            onChange={handleInputChange("expiryDate")}
            style={{ marginBottom: "10px" }}
          /> */}
          {/* {errors.expiryDate && (
            <div style={{ color: "red", marginBottom: "10px" }}>
              {errors.expiryDate}
            </div>
          )} */}

          {/* CVV Input */}
          {/* <Input
            id="unique-cvv"
            name="unique-cvv"
            autoComplete="new-cvv"
            placeholder="CVV"
            value={cardDetails.cvv}
            onChange={handleInputChange("cvv")}
            type="password"
            style={{ marginBottom: "10px" }}
          />
          {errors.cvv && (
            <div style={{ color: "red", marginBottom: "10px" }}>{errors.cvv}</div>
          )} */}
        {/* </Card> */}
      </Modal>
    </div>
  );
};

export { TrialUpdate };

